<template>
  <div class="documents" style="padding: 0 10px;">
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <file-upload
            :model="modelType"
            :model-id="model.id"
            accept=".png, .jpg, .jpeg, .gif, .xls, .xlsx, .doc, .docx, .pdf, .csv"
            :accepted-mime-types="[
              'image/png',
              'image/jpeg',
              'image/gif',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/pdf',
              'text/csv'
            ]"
            @uploaded="onFileUploaded"
          >
            <template #button="{ open }">
              <b-button type="is-light" @click="open">ATTACH FILE</b-button>
            </template>
          </file-upload>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
          <tags-input :label="'Search by Tags'" :allowNew="false" @selectedTags="filterTags" :horizontal="true" />
      </div>
    </div>
    <div
      v-for="(row, index) in chunkedDocuments"
      :key="index"
      style="flex-wrap: wrap;"
    >

    <!-- Image row -->
    <document :document="document" @deleteFile="deleteFile" v-for="document in row" :key="document.id"/>
      
    </div>
    <b-loading :is-full-page="false" :active.sync="fetchLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import FileUpload from "@/components/Documents/File/FileUpload";
import { FileService } from "@/services/file.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import Document from "./Document";
import TagsInput from "@/components/partials/TagsInput";

export default {
  fileService: FileService,
  props: {
    model: {
      required: true
    },
    modelType: {
      type: String,
      required: true
    },
  },
  components: {
    FileUpload,
    Document,
    TagsInput
  },
  data: () => ({
    allDocuments: [],
    filteredDocuments: [],
    uploading: false,
    fetchLoading: false
  }),
  watch: {
    documents(documents) {
      this.$emit("update:documents", documents);
    },
    model: {
      handler: function() {
        if(!this.fetchLoading){
          this.$nextTick(() => {
            this.fetch();
          });
        }
      },
      deep: true
    },
  },
  computed: {
    chunkedDocuments() {
      return this.filteredDocuments.reduce((result, item, index) => {
        const chunkIndex = Math.floor(index / 4);

        if (!result[chunkIndex]) {
          result[chunkIndex] = []; // start a new chunk
        }
        result[chunkIndex].push(item);

        return result;
      }, []);
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
        try {
          this.allDocuments = [];
          this.filteredDocuments = [];
          this.fetchLoading = true;
          this.allDocuments = await this.$options.fileService
            .all({
              uploadableId: this.model.id,
              uploadableType: this.modelType,
              includes: "createdBy"
            })
            .then(response => JsonDenormalizer.denormalize(response));
            
          this.filteredDocuments = this.allDocuments;
          this.fetchLoading = false;
        } catch (err) {}
    },
    onFileUploaded(file) {
      this.allDocuments.push(file);

      this.$nextTick(() => {
        this.filteredDocuments = this.allDocuments;
      });
    },
    filterTags(tags){
      if(tags.length > 0){
        this.filteredDocuments = this.allDocuments.filter(document =>{
            const test = document.tags.find(tag => {
                if(tags.includes(tag.name)){
                  return tags
                } 
            });
            if(test){
              return document
            }
        })
      }else {
        this.filteredDocuments = this.allDocuments
      }
    },
    deleteFile(file){

      let index = this.filteredDocuments.findIndex(item => {return item.id == file.id })
      this.$delete(this.filteredDocuments,index)

      this.$nextTick(() => {
        let index = this.allDocuments.findIndex(item => {return item.id == file.id })
        this.$delete(this.allDocuments,index)
      });
    }
  }
};
</script>

<style scoped>
/* .item-document {
  flex: 0 0 25%;
  display: flex;
  flex-direction: column;
  max-width: 25%;
  flex-wrap: wrap;
  padding: 0 15px;
  padding-bottom: 15px;
}
.item-document span {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  word-break: break-word;
  text-align: center;
} */
/* .bm--card-equal-height {
   display: flex;
   flex-direction: column;
   height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/Documents/ListDocuments.vue